import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 11.973v.054C.034 18.638 5.493 24 12.234 24V0C5.494 0 .034 5.357 0 11.973" }, null, -1),
    _createElementVNode("path", { d: "M12.195 23.995h12.212V0H12.201v.044c6.685 0 12.1 5.384 12.1 11.95 0 6.567-5.415 11.935-12.1 11.935v.066z" }, null, -1)
  ])))
}
export default { render: render }